import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFormOctagonRotate: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFormOctagonRotate"><Path d="M12 2L19.0711 4.92893L22 12L19.0711 19.0711L12 22L4.92893 19.0711L2 12L4.92893 4.92893L12 2Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconFormOctagonRotate;
